import * as apiMethods from '../../consts/api/apiMethods';
import {GATEWAYS} from '../../consts/app/requestParamTypes';
import {setCurrentGateway, setGateways} from '../../state/ducks/gateways';
import {makeSelectRequestParams} from '../../state/selectors/requestParams';
import {dispatch, getState} from '../../state/store';
import helpers from '../../utils/helpers';
import ApiClient from '../api/clients/apiClient';
import log from '../logger/log';
import openStreetApiService from '../map/openStreetApiService';
import {createGatewayRequestMapping, editGatewayRequestMapping, gatewayListMapping} from '../mappings/gatewaysMapping';

const getGatewaysList = async (requestParams = makeSelectRequestParams(GATEWAYS)(getState())) => {
    try {
        const response = await new ApiClient().callPost({
            methodName: apiMethods.GATEWAYS_LIST,
            requestConfig: {
                data: requestParams,
            },
            action: setGateways,
            mapper: gatewayListMapping,
        });

        return response;
    } catch (e) {
        log.error(`getGatewaysList: ${e}`);
    }
};

const getGatewayById = async (id, cities, onRequestSuccess) => {
    try {
        const response = await new ApiClient().callGet({
            methodName: apiMethods.GATEWAY_BY_ID,
            requestConfig: {
                args: id,
            },
        });

        if (!response) {
            return;
        }

        const address = await openStreetApiService.getAddressByCoordinates(response.latitude, response.longitude);
        const {city, shortAddress} = openStreetApiService.formatAddress(address.address);

        const cityID = cities?.find((c) => c.name === city)?.key || null;

        const gatewayWithAddress = {
            ...response,
            cityID,
            address: shortAddress,
        };

        dispatch(setCurrentGateway(gatewayWithAddress));
        if (onRequestSuccess) {
            helpers.runFunction(onRequestSuccess, gatewayWithAddress);
        }
    } catch (e) {
        log.error(`getGatewayById: ${e}`);
    }
};

const createGateway = async ({formData, onRequestError, onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.GATEWAYS,
            requestConfig: {
                data: createGatewayRequestMapping(formData),
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`createGateway: ${e}`);
        helpers.runFunction(onRequestError);
    }
};

const editGateway = async ({formData, onRequestSuccess, onRequestError}) => {
    try {
        await new ApiClient().callPut({
            methodName: apiMethods.GATEWAYS,
            requestConfig: {
                data: editGatewayRequestMapping(formData),
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`editGateway: ${e}`);
        helpers.runFunction(onRequestError);
    }
};

const deleteGateway = async (id, onRequestSuccess) => {
    try {
        await new ApiClient().callDelete({
            methodName: apiMethods.GATEWAYS,
            requestConfig: {
                data: {id},
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`deleteGateway: ${e}`);
    }
};

export default {
    getGatewaysList,
    getGatewayById,
    createGateway,
    editGateway,
    deleteGateway,
};
